import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CiamService } from '../../../_services/ciam.service';

@Component({
  selector: 'ng-casto-customer-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class CustomerAuthCallbackComponent implements OnInit {
  errorMessage = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly ciamService: CiamService,
  ) {}

  ngOnInit(): void {
    this.ciamService.completeAuthentication().subscribe({
      next: () => this.ciamService.navigateAfterAuthentication(
        this.route.snapshot.queryParamMap.get('activated') === 'true',
      ),
      error: error => {
        console.error('Échec du retour CIAM.', error);
        this.errorMessage = 'La connexion n’a pas pu être finalisée. Veuillez réessayer.';
      },
    });
  }

  retry(): void {
    this.ciamService.redirectToSignIn();
  }
}
